import React, { useState, useEffect } from "react"
import { Helmet } from "react-helmet"
import { currentDomain, currentPath } from "../Index"
import { promotionsData } from "../data/PromotionData"
import { useNavigate } from "react-router-dom"
import PromotionBar from "../snippets/PromotionBar"

import ModuleSpinSurprize from "./promotion_modules/modules_spinSurprize"

export default function SpinSurprize() {
  const navigate = useNavigate()
  const [activeModal, setActiveModal] = useState("")
  const [showButton, setShowButton] = useState(false)
  const data = promotionsData.find(
    (promo) => promo.title === "Saturday Spin Surprize"
  )

  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    const now = new Date()
    // const targetDate = new Date("2025-05-03T12:00:00")
    const targetDate = new Date("2025-05-10T15:00:00")
    if (now >= targetDate) {
      setShowButton(true)
    }
  }, [])

  useEffect(() => {
    document.body.style.overflow = activeModal ? "hidden" : "auto"
    return () => {
      document.body.style.overflow = "auto"
    }
  }, [activeModal])

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 841)
    }
    handleResize()
    window.addEventListener("resize", handleResize)
    return () => {
      window.removeEventListener("resize", handleResize)
    }
  }, [])

  const modalComponents = {
    "Saturday Spin Surprize": ModuleSpinSurprize,
  }

  const ActiveModal = activeModal ? modalComponents[activeModal] : null

  //If the promo page is expired - throws error
  useEffect(() => {
    if (!data) {
      navigate("/not-found")
    }
  }, [data, navigate])

  if (!data) return null
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Spin Surprize</title>
        <link rel="icon" href="/images/fav.webp" sizes="32x32" />
        <meta name="description" content="ddd" />
        <link rel="canonical" href={`${currentDomain}${currentPath}`} />
      </Helmet>
      <div className="promotion-page-main all-page-main-container-min-height">
        <div className="promotion-page-container main-container-global-adjusted-padding">
          <div className="promotion-tnc-page">
            <div className="promotion-page-breadcrumb">
              <a href="/promotion/">Promotions </a> / <span>{data.title}</span>
            </div>
            <div className="promotion-tnc-banner">
              <img
                src={isMobile ? data.imgSrc : data.bannerSrc}
                alt={`FGH ${data.title}`}
              />
            </div>
            <div className="promotion-tnc-content">
              <div className="promotion-tnc-info">
                <div
                  className={`promotion-indication-message ${data.promotionMessage.class}`}
                >
                  {data.promotionMessage.text}
                </div>
                <h1>Saturday Spin Surprize</h1>
                <h2>Free Spins Giveaway!</h2>
                <div className="promotion-tnc-period">
                  <strong>Promo Period : </strong>
                  <span>May 03 (12NN) - May 31 (11:59AM), 2025</span>
                </div>
              </div>
              <div className="promotion-tnc-mechanic-content">
                <PromotionBar />
                {/* {showButton && (
                  <button
                    className="winners-icon"
                    onClick={() => {
                      setActiveModal(data.title)
                    }}
                  >
                    Winners
                  </button>
                )} */}

                <strong>Mechanics : </strong>
                <ol>
                  <li>This promotion is open to all FGH players.</li>
                  <li>
                    Play any <strong className="highlight">BNG slots</strong>{" "}
                    available on the website.
                  </li>
                  <li>
                    A minimum of{" "}
                    <strong className="highlight">5,000 TURNOVER</strong> is
                    required weekly to get a chance for the random{" "}
                    <strong className="highlight">FREE SPINS.</strong>
                  </li>
                  <li>
                    Weekly cutoff :{" "}
                    <strong className="highlight">
                      Saturday 12:00nn - next Saturday 11:59am.
                    </strong>
                  </li>
                  <li>
                    Fifteen (15) LUCKY PLAYERS will be selected to win random
                    free spins every SATURDAY, by 3PM.
                    <div className="table-wrapper">
                      {" "}
                      <table className="promotion-tnc-table">
                        <thead>
                          <th>--</th>
                          <th>No. of Winners</th>
                          <th>No. of Free Spins</th>
                          <th>--</th>
                        </thead>
                        <tbody>
                          <tr>
                            <td>1st</td>
                            <td>1</td>
                            <td>100</td>
                            <td rowSpan={6}>No Rollover Requirement</td>
                          </tr>
                          <tr>
                            <td>2nd</td>
                            <td>1</td>
                            <td>90</td>
                          </tr>
                          <tr>
                            <td>3rd</td>
                            <td>1</td>
                            <td>80</td>
                          </tr>
                          <tr>
                            <td>4th</td>
                            <td>1</td>
                            <td>70</td>
                          </tr>
                          <tr>
                            <td>5th</td>
                            <td>1</td>
                            <td>60</td>
                          </tr>
                          <tr>
                            <td>6th - 15th</td>
                            <td>10</td>
                            <td>50</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </li>
                  <li>
                    FREE SPINS are valid exclusively on the{" "}
                    <strong className="highlight">
                      FEATURED GAME of the week.
                    </strong>
                    <div className="table-wrapper">
                      {" "}
                      <table className="promotion-tnc-table">
                        <thead>
                          <th>Week</th>
                          <th>Featuring Game</th>
                        </thead>
                        <tbody>
                          <tr>
                            <td>1</td>
                            <td>Lady Fortune</td>
                          </tr>
                          <tr>
                            <td>2</td>
                            <td>More Magic Apple</td>
                          </tr>
                          <tr>
                            <td>3</td>
                            <td>Sticky Piggy</td>
                          </tr>
                          <tr>
                            <td>4</td>
                            <td>Green Chilli 2</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </li>
                  <li>
                    Free spin <strong className="highlight">BET VALUE </strong>
                    will be determined by the winner's VIP level.
                    <div className="table-wrapper">
                      <table className="promotion-tnc-table">
                        <thead>
                          <th>VIP Level</th>
                          <th>Bet Value</th>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Alexandrite</td>
                            <td>₱7.00</td>
                          </tr>
                          <tr>
                            <td>Diamond</td>
                            <td>₱6.00</td>
                          </tr>
                          <tr>
                            <td>Ruby</td>
                            <td>₱6.00</td>
                          </tr>
                          <tr>
                            <td>Saphhire</td>
                            <td>₱4.00</td>
                          </tr>
                          <tr>
                            <td>Emerald</td>
                            <td>₱3.00</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </li>
                  <li>
                    FGH reserves the right to modify, suspend, or terminate this
                    promotion at any time without prior notice.
                  </li>
                </ol>
                <div className="promotion-tnc-cta">
                  <a href="/slots/?provider=BNG" className="promotion-cta-btn">
                    Play Now
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {ActiveModal && <ActiveModal closeModal={() => setActiveModal(null)} />}
    </>
  )
}
